import React from 'react';
import Expansion from './components/expansion';
import Star from './components/star';
import Session from './session';

import './section.scss';

export default class Section extends React.Component {
    static defaultProps = {
        watch: 'Watch video',
        download: 'Download slides',
        needSocialLoginIn: '',
        withTime: false,
        hideSectionTimeWithoutTitle: true,
        embedVideo: false,
    }
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.expandedDefault
        }
    }

    render() {
        const { data, compact } = this.props;
        const hasSessions = this.hasSessions(data);
        if(compact && !hasSessions) {
            return null;
        }
        const sessions = hasSessions ? this.renderSessions(data.sessions, data.color, compact, data.title) : null;
        const bar = this.renderBar(data, hasSessions);

        return (
            <div className='section'>
                {bar}
                {sessions}
            </div>
        );
    }

    renderBar(data, hasArrow) {
        if (!data.title) {
            return (
                <div className='no-bar'></div>
            );
        }

        const { withTime, compact } = this.props;
        const showTime = withTime && !compact;
        const titleTime = showTime && this.renderTitleTime(data);
        const titleText = this.renderTitleText(data, showTime);

        const barStyle = data.color && {
            backgroundColor: data.color
        }

        const arrow = this.renderArrow(hasArrow);

        const barClassName = 'bar' + (hasArrow ? '' : ' bar-no-content');

        return (
            <div className={barClassName} style={barStyle} onClick={this.onClickBar}>
                <div className='title row'>
                    {titleTime}
                    {titleText}
                </div>
                {arrow}
            </div>
        );
    }

    renderArrow(hasArrow) {
        const className = 'arrow' + (this.state.expanded ? ' expanded' : '') + (hasArrow ? ' show-arrow' : '');

        return (
            <div className={className}>
                <svg with='37' height='16' fill='transparent' viewBox='0 0 37 16'>
                    <path d='M 2 2 L 18 14 L 35 2' stroke='rgba(255, 255, 255, 0.5)' strokeWidth='2' />
                </svg>
            </div>
        );
    }

    renderTitleTime(data) {
        if (!data.start && !data.end) return null;

        const text = data.end ? `${data.start} - ${data.end}` : `${data.start}`;
        const trimedText = text.replace(/ AM/g, 'am').replace(/ PM/g, 'pm');

        return (
            <div className='col-lg-3 col-md-4 col-sm-4 col-3 title-time-col'>
                <div className='title-time'>
                    {trimedText}
                </div>
            </div>
        );
    }

    renderTitleText(data, showTime) {
        if(showTime) {
            return (
                <div className='col-lg-9 col-md-8 col-sm-8 col-9 title-text-col'><div className='title-text'>{data.title}</div></div>
            );
        }

        return (
            <div className='col-12'><span>{data.title}</span></div>
        );
    }

    renderSessions(data, color, compact, collapsable) {
        if (!data) return null;
        const sessions = data.map(i => {
            return (
                <Session key={i.id}
                    removeSectionTimeWithoutTitle={this.props.removeSectionTimeWithoutTitle}
                    watch={this.props.watch}
                    download={this.props.download}
                    needSocialLoginIn={this.props.needSocialLoginIn}
                    embedVideo={this.props.embedVideo}
                    compact={compact}
                         hideBookmarks={this.props.hideBookmarks}
                         speakerFormat={this.props.speakerFormat}
                    data={i}
                    color={color}
                    book={this.props.book}
                    onBeforeUpdateBookmark={this.props.onBeforeUpdateBookmark}
                    onUpdateBookmark={this.props.onUpdateBookmark}
                    onClickSpeaker={this.props.onClickSpeaker} />
            )
        });

        const x = compact ? 5 : 3;
        const xx = compact ? 8 : 4;
        const className = sessions.length >= xx ? 'xx' : (sessions.length >= x ? 'x' : '');
        return (
            <Expansion className={className} expanded={collapsable ? this.state.expanded : true}>
                {sessions}
            </Expansion>
        );
    }

    onClickBar = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    hasSessions(data) {
        const sessions = (data.sessions || []);
        if (sessions.length == 0) return false;

        return sessions.reduce((acc, i) => {
            return acc || (i.title || i.description);
        }, false);
    }
}
